import { createPortal } from 'react-dom';
import Box from '@mui/material/Box';
import { keyframes } from '@mui/material/styles';

// Loading animation - slides across the screen
const loadingSlide = keyframes`
  0% { transform: translateX(-100%); }
  50% { transform: translateX(0%); }
  100% { transform: translateX(100%); }
`;

// ==============================|| LOADER ||============================== //

export default function Loader() {
  const loader = (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        width: '100vw',
        height: 3,
        overflow: 'hidden',
        backgroundColor: 'rgba(99, 102, 241, 0.08)',
      }}
    >
      <Box
        sx={{
          width: '40%',
          height: '100%',
          background: 'linear-gradient(90deg, transparent, #6366f1 20%, #818cf8 50%, #6366f1 80%, transparent)',
          animation: `${loadingSlide} 1.2s ease-in-out infinite`,
        }}
      />
    </Box>
  );

  // Use portal to render at document body level, avoiding any parent transforms
  if (typeof document !== 'undefined') {
    return createPortal(loader, document.body);
  }

  return loader;
}
